import React, { useState } from 'react'
import Footer from '../Layout/Footer'
import Header from '../Layout/Header'
import { useEffect } from 'react'
import { masterData, ClientList } from '../../Api/Master'
import { ProjectCreateSingle, validateFormData } from '../../Api/Project'
import { useNavigate, useLocation } from "react-router-dom";
import { ProjecGroupDetail, ProjectCreateGroupChild } from '../../Api/ProjectGroup'
import { format } from 'date-fns'
import { userList } from '../../Api/User'

function Group_project_child_add() {
    const defaultStartDate = Math.floor(new Date().getTime()/1000);
    const defaultEndDate = Math.floor(new Date(new Date().setDate(new Date().getDate() + 365)).getTime()/1000);

    const navigate = useNavigate();
    const location = useLocation();
    useEffect(() => {
        document.title = "Group Project child - Mindforce"
    },);

    const [clients, setClients] = useState();
    const [projectManagers, setProjectManager] = useState();
    const [teams, setTeams] = useState();
    const [countries, setCountries] = useState();
    const [languages, setLanguages] = useState();
    const [projectCategories, setProjectCategories] = useState();
    const [currencies, setCurrencies] = useState();
    const [projectFilters, setProjectFilters] = useState();
    const [selectedProjectFileter, setSelectedProjectFilter] = useState([])
    const [securityFilters, setSecurityFilters] = useState();
    const [selectedSecurityFilter, setSelectedSecurityFilter] = useState([])
    const [deviceFilters, setDeviceFilters] = useState();
    const [selectedDeviceFilter, setSelectedDeviceFilter] = useState([])
    const [deviceFilterError, setDeviceFilterError] = useState()
    const [detail, setDetail] = useState();
    const [form, setForm] = useState({startDate:defaultStartDate, endDate:defaultEndDate});
    const [uniqueIP, setUniqueIp] = useState();
    const [showUniqueIp, setShowUniqueIp] = useState(false)
    const [speeder, setSpeeder] = useState();
    const [showSpeeder, setShowSpeeder] = useState(false)
    const [uniqueIPError, setUniqueIPError] = useState()
    const [speederError, setSpeederError] = useState()
    const [errors, setErrors] = useState({});
    const [startDate, setStartDate]= useState(format(new Date(format(new Date(new Date().setDate(new Date().getDate() + 30)),'yyyy-MM-dd')),'yyyy-MM-dd'))
    const [endDate, setEndDate] = useState(format(new Date(new Date().setDate(new Date().getDate() + 30)),'yyyy-MM-dd'));

    const getProjectFilterIdBySlug = (slug) =>
        projectFilters?.find((filter) => filter?.slug === slug)?.id?.toString();

    const prescreenFilterId = getProjectFilterIdBySlug('prescreen') || '418';
    const captchaFilterId = getProjectFilterIdBySlug('captcha');
    const isCaptchaEnabled = !!captchaFilterId && selectedProjectFileter.includes(captchaFilterId);

    useEffect(() => {
        getDetail()
    },[])

    useEffect(() => {
        getClients()
        getCountries()
        // getLanguages()
        getProjectCategories()
        getCurrencies()
        getProjectFilters()
        getSecurityFilters()
        getDeviceFilter()
        getProjectManagers()
        getTeams()
    },[])

    useEffect(() => {
        getLanguages()
    },[form?.countryID])

    const getProjectManagers = async() => {
        let res = await userList({page:0, searchKeyword:'',role:"project-manager"});

        if(res.status === 1){
            setProjectManager(res.payload)
        }        
    }

    const getTeams = async() => {
        let res = await masterData({moduleName:'team'})
        if(res?.status === 1){
            setTeams(res.payload)
        }
    }

    const getDetail = async () => {
        let res = await ProjecGroupDetail({id:location.state})
        if(res.status === 1){
            setDetail(res.payload[0]);
        }
    }

    const getClients = async() => {
        let res = await ClientList({page:0, searchKeyword:''})
        if(res.status === 1){
            setClients(res.payload)
        }
    }

    const getCountries = async() => {
        let res = await masterData({moduleName:'country'})
        if(res.status === 1){
            setCountries(res.payload)
        }
    }

    const getLanguages = async() => {
        let res = await masterData({moduleName:'language',countryID:form?.countryID})
        if(res.status === 1){
            setLanguages(res.payload)
        }
    }

    const getProjectCategories = async() => {
        let res = await masterData({moduleName:'product-category'})
        if(res.status === 1){
            setProjectCategories(res.payload)
        }
    }

    const getCurrencies = async() => {
        let res = await masterData({moduleName:'currency'})
        if(res.status === 1){
            setCurrencies(res.payload)
        }
    }

    const getProjectFilters = async() => {
        let res = await masterData({moduleName:'project-filters'})
        if(res.status === 1){
            setProjectFilters(res.payload)
        }
    }

    const getSecurityFilters = async() => {
        let res = await masterData({moduleName:'security-filters'})
        if(res.status === 1){
            setSecurityFilters(res.payload)
        }
    }

    const getDeviceFilter = async() => {
        let res = await masterData({moduleName:'device-filters'})
        if(res.status === 1){
            setDeviceFilters(res.payload)
            let data = []
            res?.payload?.forEach(ele => {
                data.push(ele?.id.toString());
            });
            setSelectedDeviceFilter(data)
        }
    }

    const setField = (field, value) => {
        setForm({
            ...form,
            [field]: value
        })
        if (!!errors[field])
            setErrors({
                ...errors,
            [field]: null
        })
    }

    const handleDates = (e, type) => {
        let date = Math.floor(new Date(e.target.value?.toString()).getTime()/1000)
        switch (type) {
            case 'startDate':
                form.startDate = date
                setStartDate(format(new Date(date*1000), 'yyyy-MM-dd'))
                break;
            case 'endDate':
                form.endDate = date
                setEndDate(format(new Date(date*1000), 'yyyy-MM-dd'))
                break;
        
            default:
                break;
        }
    }
    const handleProjectFilter = (e) => {
        const {value, checked} = e.target;
        const slug = e.target.dataset?.key

        if (slug === 'prescreen' && !checked && isCaptchaEnabled) {
            return;
        }

        let updatedProjectFilters = checked
            ? [...new Set([...selectedProjectFileter, value])]
            : selectedProjectFileter.filter((s) => s !== value);

        if (slug === 'captcha' && checked && !updatedProjectFilters.includes(prescreenFilterId)) {
            updatedProjectFilters = [...updatedProjectFilters, prescreenFilterId];
        }
        if (checked) {
            if(slug === 'unique-ip'){
                setUniqueIp(1)
                setShowUniqueIp(true)
            }
            if(slug === 'speeder'){
                setShowSpeeder(true)
            }
        } else {
            if(slug === 'unique-ip'){
                setUniqueIp(null)
                setShowUniqueIp(false)
            }
            if(slug === 'speeder'){
                setShowSpeeder(false)
            }
        }
        setSelectedProjectFilter(updatedProjectFilters);
    }

    const handleSecurityFilter = (e) => {
        const {value, checked} = e.target;
        if (checked) {
            setSelectedSecurityFilter([...selectedSecurityFilter, value]);
        } else {
            setSelectedSecurityFilter(selectedSecurityFilter.filter((s) => s !== value));
        }
    }

    const handleDeviceFilter = (e) => {
        const {value, checked} = e.target;
        if (checked) {
            setSelectedDeviceFilter([...selectedDeviceFilter, value]);
        } else {
            setSelectedDeviceFilter(selectedDeviceFilter.filter((s) => s !== value));
        }
    }

    const handlesubmit = async (e) => {
        e.preventDefault();
        setErrors()
        setDeviceFilterError()
        setSpeederError()
        setUniqueIPError()
        const normalizedSelectedProjectFilters = [...selectedProjectFileter];
        if (captchaFilterId && normalizedSelectedProjectFilters.includes(captchaFilterId) && !normalizedSelectedProjectFilters.includes(prescreenFilterId)) {
            normalizedSelectedProjectFilters.push(prescreenFilterId);
            setSelectedProjectFilter(normalizedSelectedProjectFilters);
        }
        let proFilter = [];
        let value = null;
        let uniqueIpErrorCount = 0;
        let speederErrorCount = 0;
        projectFilters?.forEach(p => {
            let status = 1
            if(normalizedSelectedProjectFilters.indexOf(p.id.toString()) === -1){
                status = 0;
            }
            if(p.id === 420 && status===1){
                if(uniqueIP){
                    value = uniqueIP
                }else{
                    uniqueIpErrorCount = uniqueIpErrorCount + 1;
                    value = null
                }
                
            }
            else if(p.id === 421 && status===1){
                if(speeder){
                    value=speeder
                }else{
                    speederErrorCount = speederErrorCount + 1;
                    setSpeederError("Required")
                    value = null
                }
                // value = speeder
                
            }else{
                value = null;
            }
            proFilter.push({id:p.id, status:status, value:value})
        });

        let secFilter = [];
        securityFilters?.forEach(s => {
            let status = 1
            if(selectedSecurityFilter.indexOf(s.id.toString()) === -1){
                status = 0;
            }
            secFilter.push({id:s.id, status:status, value:null})
        });

        let devFilter = [];
        let isDeviceFilterExist = deviceFilters?.length;
        deviceFilters?.forEach(d => {
            let status = 1
            if(selectedDeviceFilter.indexOf(d.id.toString()) === -1){
                status = 0;
                isDeviceFilterExist = isDeviceFilterExist-1;
            }
            devFilter.push({id:d.id, status:status, value:null})
        });
        form.projectFilters = proFilter;
        form.securityFilters = secFilter;
        form.deviceFilters = devFilter;
        form.respondentClickQuota = 10000000;
        const formErrors = validateFormData(form)
        if(Object.keys(formErrors).length > 0){
            setErrors(formErrors)
        }else{
            if(isDeviceFilterExist < 1){
                setDeviceFilterError("Required")
                return false;
            }
            if(uniqueIpErrorCount > 0){
                setUniqueIPError("Required")
                return false;
            }
            if(speederErrorCount > 0){
                setSpeederError("Required")
                return false;
            }
            let payload = {
                parentProjectID : location.state,
                childProject: [form]
            }
            let res = await ProjectCreateGroupChild({payload:payload});
            if(res.status === 1){
                // window.location.reload();
                navigate("/group-project-child-detail?id=" + res?.payload.projectDetailID);
            }else{
                setErrors({...errors,['submit']:res.message})
            }
        }
        
    }
    return (
        <div>
            <Header />
            <div id="layout-wrapper">
                <div className="main-content">

                    <div className="page-content">
                        <div className="container-fluid">

                            <div className="row">
                                <div className="col-12 col-lg-12">
                                    <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                        <div>
                                        <div className="page-title-right">
                                            <ol className="breadcrumb m-0">
                                                <li className="breadcrumb-item"><a>Project</a></li>
                                                <li className="breadcrumb-item active">Group Project</li>
                                            </ol>
                                        </div>
                                        <h4 className="mb-sm-0">Group Project</h4>
                                        </div>
                                        

                                    </div>
                                </div>
                            </div>
                            {/* <!-- end page title --> */}

                            <div className="row">
                                <div className="col-xl-12 col-lg-12">
                                    <div className="card">

                                        {/* <!-- end card header --> */}

                                        <div className="card-body">
                                            <div className="">
                                                <form >
                                                    <div className="row">
                                                        <div className="col-md-4">
                                                            <div className="mb-3">
                                                                <label className="form-label mb-0">Group Name <span className="required_field">*</span></label>
                                                                <input type="text" className="form-control" placeholder="Enter project name" disabled={true} readOnly={true} defaultValue={detail?.fullName} />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="mb-3">
                                                                <label htmlFor="ProjectName" className="form-label mb-0">Project Name <span className="required_field">*{errors?.fullName}</span></label>
                                                                <input type="text" className="form-control" placeholder="Enter project name" id="fullName"  onChange={(e) => setField('fullName',e.target.value)} />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="mb-3">
                                                                <label htmlFor="Projectdescription" className="form-label mb-0">Project Description <span className="required_field">{errors?.description}</span></label>
                                                                <input type="text" className="form-control" placeholder="Enter project description" id="description" onChange={(e) => setField('description',e.target.value)} />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-2">
                                                            <div className="mb-3">
                                                                <label htmlFor="ForminputState" className="form-label mb-0">Client <span className="required_field">*{errors?.clientID}</span></label>
                                                                <select id="ForminputState" className="form-select" data-choices data-choices-sorting="true"  disabled={true} readOnly={true} onChange={(e) => setField('clientID',e.target.value)}>
                                                                    <option value={""} disabled selected>Select Client</option>
                                                                    {clients?.map((client) => {
                                                                        // return (<option value={client.clientID} selected={client?.clientID === detail?.clientID ? true : false}>{client.clientCode+ ' : ' +client.clientName}</option>)
                                                                        return (<option value={client.clientID} selected={client?.clientID === detail?.clientID ? true : false}>{client.clientName}</option>)
                                                                    })}
                                                                </select>
                                                            </div>
                                                        </div>                                                        
                                                        
                                                        {/* <!--end col--> */}
                                                        <div className="col-md-2">
                                                            <div className="mb-3">
                                                                <label htmlFor="ProjectManager" className="form-label mb-0">Project Manager <span className="required_field">*{errors?.managerID}</span></label>
                                                                {/* <input type="text" className="form-control" placeholder="Enter field" id="managerName" onChange={(e) => setField('managerName',e.target.value)} /> */}
                                                                <select id="managerID" className="form-select" data-choices data-choices-sorting="true"  defaultValue={form?.managerID} onChange={(e) => setField('managerID',e.target.value)}>
                                                                    <option value={""} disabled selected>Select Project Manager</option>
                                                                    {projectManagers?.map((manager) => {
                                                                        return (<option value={manager.ID} selected = {form?.managerID == manager.ID? true:false} >{manager.firstName+" "+manager.lastName}</option>)
                                                                    })}
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-2">
                                                            <div className="mb-3">
                                                                <label htmlFor="teamID" className="form-label mb-0">Team <span className="required_field">*{errors?.teamID}</span></label>
                                                                <select id="teamID" className="form-select" data-choices data-choices-sorting="true" onChange={(e) => setField('teamID',e.target.value)}>
                                                                    <option value={""} disabled selected>Select Team</option>
                                                                    {teams?.map((team) => {
                                                                        return (<option value={team.id}>{team.name}</option>)
                                                                    })}
                                                                </select>
                                                            </div>
                                                        </div>
                                                        {/* <!--end col--> */}
                                                        <div className="col-md-2">
                                                            <div className="mb-3">
                                                                <label htmlFor="ForminputState" className="form-label mb-0">Project Country <span className="required_field">*{errors?.countryID}</span></label>
                                                                <select id="ForminputState" className="form-select" data-choices data-choices-sorting="true" onChange={(e) => setField('countryID',e.target.value)}>
                                                                    <option value={""} disabled selected>Select Country</option>
                                                                    {countries?.map((country) => {
                                                                        return (<option value={country.id}>{country.name}</option>)
                                                                    })}
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-2">
                                                            <div className="mb-3">
                                                                <label htmlFor="ForminputState" className="form-label mb-0">Project Language <span className="required_field">*{errors?.languageID}</span></label>
                                                                <select id="ForminputState" className="form-select" data-choices data-choices-sorting="true" onChange={(e) => setField('languageID',e.target.value)}>
                                                                    <option value={""} disabled selected>Select Language</option>
                                                                    {languages?.map((language) => {
                                                                        return (<option value={language.id}>{language.name}</option>)
                                                                    })}
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-2">
                                                            <div className="mb-3">
                                                                <label htmlFor="Projectdescription" className="form-label mb-0">Currency <span className="required_field">*{errors?.currencyID}</span></label>
                                                                <select id="ForminputState" className="form-select" data-choices data-choices-sorting="true" onChange={(e) => setField('currencyID',e.target.value)}>
                                                                    <option value={""} disabled selected>Select </option>
                                                                    {currencies?.map((currency) => {
                                                                        return (<option value={currency.id}>{currency.name}</option>)
                                                                    })}
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-2">
                                                            <div className="mb-3">
                                                                <label htmlFor="ForminputState" className="form-label mb-0">Project Category <span className="required_field">*{errors?.categoryID}</span></label>
                                                                <select id="ForminputState" className="form-select" data-choices data-choices-sorting="true" onChange={(e) => setField('categoryID',e.target.value)}>
                                                                    <option value={""} disabled selected>Select Category</option>
                                                                    {projectCategories?.map((projectCategory) => {
                                                                        return (<option value={projectCategory.id}>{projectCategory.name}</option>)
                                                                    })}
                                                                </select>
                                                            </div>
                                                        </div>
                                                        {/* <!--end col--> */}
                                                        
                                                    </div>
                                                    <div className='row'>
                                                        <div className="col-md-2">
                                                            <div className="mb-3">
                                                                <label htmlFor="Projectdescription" className="form-label mb-0">LOI(Minute) <span className="required_field">*{errors?.loi}</span></label>
                                                                <input type="text" className="form-control" placeholder="Enter " id="loi" onChange={(e) => setField('loi',e.target.value)} />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-2">
                                                            <div className="mb-3">
                                                                <label htmlFor="Projectdescription" className="form-label mb-0">IR(%) <span className="required_field">*{errors?.ir}</span></label>
                                                                <input type="text" className="form-control" placeholder="Enter " id="Projectdescription" onChange={(e) => setField('ir',e.target.value)} />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-2">
                                                            <div className="mb-3">
                                                                <label htmlFor="Projectdescription" className="form-label mb-0">Sample Size <span className="required_field">*{errors?.sampleSize}</span></label>
                                                                <input type="text" className="form-control" placeholder="0" id="Projectdescription" onChange={(e) => setField('sampleSize',e.target.value)} />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-2 ">
                                                            <div className="mb-3">
                                                                <label htmlFor="Projectdescription" className="form-label mb-0">Respondent Click Quota <span className="required_field">*{errors?.respondentClickQuota}</span></label>
                                                                <input type="text" className="form-control disabled" placeholder="0" id="Projectdescription" value={10000000} onChange={(e) => setField('respondentClickQuota',e.target.value)} />
                                                            </div>
                                                        </div>

                                                        {/*  */}
                                                        
                                                        <div className="col-md-2">
                                                            <div className="mb-3">
                                                                <label htmlFor="Projectdescription" className="form-label mb-0">Project CPI <span className="required_field">*{errors?.projectCPI}</span></label>
                                                                <input type="text" className="form-control" placeholder="Enter " id="Projectdescription" onChange={(e) => setField('projectCPI',e.target.value)} />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-2">
                                                            <div className="mb-3">
                                                                <label htmlFor="Projectdescription" className="form-label mb-0">Supplier CPI <span className="required_field">*{errors?.supplierCPI}</span></label>
                                                                <input type="text" className="form-control" placeholder="0" id="Projectdescription" onChange={(e) => setField('supplierCPI',e.target.value)} />
                                                            </div>
                                                        </div>
                                                    {/* </div>
                                                    <div className='row'> */}
                                                        <div className='col-md-2 d-none1'>
                                                        <div className="mb-3" style={{ position: "relative" }}>
                                                            <label htmlFor="startDate" className="form-label mb-0">Start Date<span className="required_field">*{errors?.startDate}</span></label>
                                                            <input
                                                                type="date"
                                                                className="form-control"
                                                                id="dateInput"
                                                                value={form?.startDate ? format(new Date(form?.startDate * 1000), 'yyyy-MM-dd') : ""}
                                                                onChange={(e) => {
                                                                    handleDates(e, 'startDate');
                                                                    setForm({
                                                                        ...form,
                                                                        startDate: Math.floor(new Date(e.target.value).getTime() / 1000)
                                                                    });
                                                                }}
                                                            />
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={form?.startDate ? format(new Date(form?.startDate * 1000), 'dd MMM yyyy') : format(new Date(), 'dd MMM yyyy')}
                                                                readOnly={true}
                                                                style={{
                                                                    position: "absolute",
                                                                    top: "17px",
                                                                    width: "70%",
                                                                    borderRightStyle: "none",
                                                                    borderTopRightRadius: "0",
                                                                    borderBottomRightRadius: "0"
                                                                }}
                                                            />
                                                        </div>
                                                        </div>
                                                        <div className='col-md-2 d-none1'>
                                                            <div className="mb-3" style={{ position: "relative" }}>
                                                                <label htmlFor="endDate" className="form-label mb-0">End Date <span className="required_field">*{errors?.endDate}</span></label>
                                                                <input
                                                                    type="date"
                                                                    className="form-control"
                                                                    id="exampleInputdate"
                                                                    value={form?.endDate ? format(new Date(form?.endDate * 1000), 'yyyy-MM-dd') : ""}
                                                                    onChange={(e) => {
                                                                        handleDates(e, 'endDate');
                                                                        setForm({
                                                                            ...form,
                                                                            endDate: Math.floor(new Date(e.target.value).getTime() / 1000)
                                                                        });
                                                                    }}
                                                                />
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    value={form?.endDate ? format(new Date(form?.endDate * 1000), 'dd MMM yyyy') : format(new Date(), 'dd MMM yyyy')}
                                                                    readOnly={true}
                                                                    style={{
                                                                        position: "absolute",
                                                                        top: "17px",
                                                                        width: "70%",
                                                                        borderRightStyle: "none",
                                                                        borderTopRightRadius: "0",
                                                                        borderBottomRightRadius: "0"
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                        
                                                        <div className="form_divide"><hr ></hr></div>
                                                        <h1 className="project_filter">Project Filter</h1>
                                                        {projectFilters?.map((row) => {
                                                            return (
                                                                <div className="col-md-3">
                                                                    <div className="form-check mb-3" style={{display:"flex"}}>
                                                                        <input className="form-check-input" type="checkbox" data-key={row?.slug} id={"projectFilter"+row.id} value={row.id} checked={selectedProjectFileter.includes(row.id.toString()) || ((row?.slug === "prescreen" || row?.id === 418) && isCaptchaEnabled)} onChange={(e) => handleProjectFilter(e)} style={{marginRight:"4px"}} disabled={(row?.slug === "prescreen" || row?.id === 418) && isCaptchaEnabled} />
                                                                        <label className="form-check-label"htmlFor={"projectFilter"+row.id} style={{float:"left", marginRight:"4px"}}>
                                                                            {row.name}
                                                                        </label>
                                                                        {(row.slug =="unique-ip" && showUniqueIp ? (<>
                                                                            <span className="required_field">*{uniqueIPError}</span>
                                                                            <input type="text" className="small-input" style={{height:"20px", width:"50px"}} placeholder="" id="UniqueIP" defaultValue={uniqueIP} onChange={(e) => setUniqueIp(e.target.value)}  />
                                                                        </>) : (<></>))}
                                                                          {row.slug =="speeder" && showSpeeder ? (<>
                                                                            <span className="required_field">*{speederError}</span>
                                                                            <input type="text" className="small-input" style={{height:"20px", width:"50px"}} placeholder="" id="Speeder" defaultValue={speeder} onChange={(e) => setSpeeder(e.target.value)}  /> 
                                                                          </>) : (<></>)}
                                                                        {/* {
                                                                            row.name =="Unique IP" &&
                                                                            <input type="text" className="small-input" style={{height:"20px", width:"50px"}} defaultValue={uniqueIP} onChange={(e) => setUniqueIp(e.target.value)} />
                                                                        }
                                                                          {
                                                                            row.name =="Speeder" &&
                                                                            <input type="text" className="small-input" style={{height:"20px", width:"50px"}} defaultValue={speeder} onChange={(e) => setSpeeder(e.target.value)} />
                                                                        } */}
                                                                    </div>
                                                                </div>
                                                            )
                                                        })}
                                                        <div className="form_divide"><hr ></hr></div>
                                                        <h1 className="project_filter">Security Filter</h1>
                                                        {securityFilters?.map((row) => {
                                                            return (
                                                                <div className="col-md-3">
                                                                    <div className="form-check mb-3">
                                                                        <input className="form-check-input" type="checkbox" id={"securityFilter"+row.id} value={row.id} onChange={(e) => handleSecurityFilter(e)} />
                                                                        <label className="form-check-label"htmlFor={"securityFilter"+row.id}>
                                                                            {row.name}
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            )
                                                        })}

                                                        <div className="form_divide"><hr ></hr></div>
                                                        <h1 className="project_filter">Device Filter <span className="required_field">*{deviceFilterError}</span></h1>
                                                        {deviceFilters?.map((row) => {
                                                            return (
                                                                <div className="col-md-3">
                                                                    <div className="form-check mb-3">
                                                                        <input className="form-check-input" type="checkbox" id={"deviceFilter"+row.id} value={row.id} onChange={(e) => handleDeviceFilter(e)} defaultChecked={true} />
                                                                        <label className="form-check-label"htmlFor={"deviceFilter"+row.id}>
                                                                            {row.name}
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            )
                                                        })}

                                                        <div className="form_divide"><hr ></hr></div>
                                                        <div className="col-md-12">
                                                            <div className="mb-3">
                                                                <label htmlFor="exampleFormControlTextarea5" className="form-label mb-0">Notes </label>
                                                                <textarea className="form-control" id="exampleFormControlTextarea5" rows="3" onChange={(e) => setField('notes',e.target.value)}></textarea>
                                                                <span className="max_char">Maximum limit of characters 250</span>
                                                            </div>
                                                        </div>


                                                        <div className="col-lg-12">
                                                            <div className="text-end">
                                                                <button type="submit" className="btn btn-primary mx-2" onClick={handlesubmit}>Submit</button>
                                                                <button type="submit" className="btn btn-secondary">Cancel</button>
                                                            </div>
                                                        </div>


                                                        {/* <!--end col--> */}
                                                    </div>
                                                    {/* <!--end row--> */}
                                                </form>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                {/* <!-- end col --> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default Group_project_child_add